define( function() {
	"use strict";

	return ( /^margin/ );
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/jquery/src/css/var/rmargin.js
// module id = 286
// module chunks = 1